import { Button, Modal, Form, Input, DatePicker, message } from "antd";
import { useAddCustomerMutation } from "../../../redux/Service/api";

const AddClient = ({ openModal, setOpenModal }: any) => {
  const [form] = Form.useForm();

  const [addCustomer, { isLoading }] = useAddCustomerMutation();

  const handleAddCustomer = async () => {
    try {
      const values = await form.validateFields();
      const customerPayload = {
        CustomerName: values.CustomerName,
        Address: values.Address,
        Phone: values.Phone,
        Mobile: values.Mobile,
        Email: values.Email,
        FirstBalDate: values.FirstBalDate.format("YYYY-MM-DDTHH:mm:ss"),
      };

      await addCustomer(customerPayload);
      message.success("تمت إضافة العميل بنجاح");
      form.resetFields();
      setOpenModal(false);
    } catch (error) {
      console.error("خطأ أثناء إضافة العميل:", error);
      message.error("فشل في إضافة العميل. يرجى المحاولة مرة أخرى.");
    }
  };

  return (
    <Modal
      title="إضافة عميل"
      centered
      open={openModal}
      onCancel={() => {
        setOpenModal(false);
        form.resetFields();
      }}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        name="add_customer_form"
        onFinish={handleAddCustomer}
      >
        <Form.Item
          label="اسم العميل"
          name="CustomerName"
          rules={[{ required: true, message: "يرجى إدخال اسم العميل" }]}
        >
          <Input size="large" placeholder="أدخل اسم العميل" />
        </Form.Item>

        <Form.Item
          label="العنوان"
          name="Address"
          rules={[{ required: true, message: "يرجى إدخال العنوان" }]}
        >
          <Input size="large" placeholder="أدخل العنوان" />
        </Form.Item>

        <Form.Item label="الهاتف" name="Phone">
          <Input size="large" placeholder="أدخل رقم الهاتف" />
        </Form.Item>

        <Form.Item label="الجوال" name="Mobile">
          <Input size="large" placeholder="أدخل رقم الجوال" />
        </Form.Item>

        <Form.Item
          label="البريد الإلكتروني"
          name="Email"
          rules={[{ type: "email", message: "يرجى إدخال بريد إلكتروني صحيح" }]}
        >
          <Input size="large" placeholder="أدخل البريد الإلكتروني" />
        </Form.Item>

        <Form.Item
          label="تاريخ الرصيد الأولي"
          name="FirstBalDate"
          rules={[{ required: true, message: "يرجى اختيار تاريخ" }]}
        >
          <DatePicker
            size="large"
            className="w-full"
            placeholder="اختر التاريخ"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            className="w-full"
          >
            إضافة
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddClient;
